<template>
  <el-dialog 
    :lang="$i18n.locale" 
    :title="$t('commonInfo.productInfo')" 
    :visible.sync="popup" 
    :close-on-click-modal="false" 
    width="800px"
    :append-to-body="true"
    @close="handleCloseDialog"
  >
    <el-table 
      style="margin:5px 10px;width: calc(100% - 10px)" 
      :data="rowData.productList" 
      border
    >
      <el-table-column 
        :label="$t('commonInfo.clientProductCode')" 
        align="center" 
        min-width="180px" 
        prop="companyProductCode" 
      />
      <el-table-column v-if="rowData.itemType == 'SKU'"
        :label="$t('commonInfo.count')" 
        min-width="140px" 
        align="center" 
        prop="productAmount" 
      />
      <el-table-column 
        :label="$t('ksaWhFBXOrderPage.newSku')" 
        min-width="180px" 
        align="center" 
        prop="skuNew" 
      />
      <el-table-column 
        :label="$t('ksaWhFBXOrderPage.newSkuCount')" 
        min-width="140px" 
        align="center" 
        prop="swapCnt" 
      />
    </el-table>
    <div slot="footer" class="dialog-footer">
		<el-button @click="handleCloseDialog">{{$t('commonInfo.dialogBtnCancel')}}</el-button>
	</div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CheckProduct',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {} 
    }
  },
  watch: {
		visible(val) {
			if (val) {
				this.popup = val;
			}
		},
	},
  data() {
		return {
			popup: false,
		};
	},
  methods: {
    handleCloseDialog() {
      this.popup = false; 
      this.$parent.productPopup = false;
    }
  }
};
</script>

<style scoped>

</style>